import { createSlice } from "@reduxjs/toolkit";
import { fetchSupplierOutflow, fetchSupplierOutflowMatrix } from "./supplierOutflowThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    supplierId: null,
    fromDate: null,
    toDate: null,
  },
  totalOutflow: 0,
  matrix: {
    list: [],
    loading: false,
    filters: {
      year: null,
    },
  },
};

const supplierOutflowSlice = createSlice({
  name: "supplierOutflow",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setMatrixFilters: (state, action) => {
      state.matrix.filters = { ...state.matrix.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierOutflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSupplierOutflow.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.accounts || [];
        state.totalOutflow = action.payload.total_outflow || 0;
      })
      .addCase(fetchSupplierOutflow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchSupplierOutflowMatrix.pending, (state) => {
        state.matrix.loading = true;
      })
      .addCase(fetchSupplierOutflowMatrix.fulfilled, (state, action) => {
        state.matrix.loading = false;
        state.matrix.list = action.payload.rows || [];
      })
      .addCase(fetchSupplierOutflowMatrix.rejected, (state) => {
        state.matrix.loading = false;
      });
  },
});

export const { setFilters, setMatrixFilters } = supplierOutflowSlice.actions;
export default supplierOutflowSlice.reducer;
